import type { SVGProps } from 'react';

export const Search = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' height='24' width='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='m20.71 19.29-5-5a.993.993 0 0 0-.95-.25l-.32-.32A6.469 6.469 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.32.32c-.08.33-.01.69.25.95l5 5c.19.2.44.3.7.3s.51-.1.71-.29c.39-.39.39-1.03 0-1.42zM9.5 14C7.02 14 5 11.98 5 9.5S7.02 5 9.5 5 14 7.02 14 9.5 11.98 14 9.5 14z' />
    </svg>
);
